import type { ButtonProps } from "antd";
import { FC } from "react";

import { StyledButton } from "./Styled";

interface Props extends ButtonProps {
    onClick?: () => void;
    children: React.ReactNode;

    margin?: string;
    marginTop?: string;
    marginBottom?: string;
    marginLeft?: string;
    marginRight?: string;
    bgColor?: "success";
}

const BaseButton: FC<Props> = ({ onClick, children, ...rest }) => {
    return (
        <StyledButton onClick={onClick} {...rest}>
            {children}
        </StyledButton>
    );
};

export default BaseButton;
